<div id="preview" #preview>
  <div *ngIf="isInitializing">Loading preview... Please wait.</div>
</div>